// Module
var code = "<react-component name=\"BulkDeleteEvents\"></react-component>\n";
// Exports
module.exports = code;